export default {
  SET_SELECTED_SUBSCRIPTION_RADIO: 'SET_SELECTED_SUBSCRIPTION_RADIO',
  SUBSCRIPTION_PLANS_RECEIVED: 'SUBSCRIPTION_PLANS_RECEIVED',
  SUBSCRIPTION_PLANS_FAILED: 'SUBSCRIPTION_PLANS_FAILED',
  SUBSCRIPTION_PROFILE_RECEIVED: 'SUBSCRIPTION_PROFILE_RECEIVED',
  SUBSCRIPTION_PROFILE_FAILED: 'SUBSCRIPTION_PROFILE_FAILED',
  SUBSCRIPTION_CANCELED: 'SUBSCRIPTION_CANCELED',
  SUBSCRIPTION_CANCEL_FAILED: 'SUBSCRIPTION_CANCEL_FAILED',
  SUBSCRIPTION_SET_PAYMENT_ACCOUNT: 'SUBSCRIPTION_CANCEL_FAILED',
  NEW_SUBSCRIPTION_FAILURE: 'NEW_SUBSCRIPTION_FAILURE',
  SET_SHARES_COUNT: 'SET_SHARES_COUNT',
  SET_DISCS_COUNT: 'SET_DISCS_COUNT'
};


// WEBPACK FOOTER //
// ./src/account/actions/subscription-plan-action-types.js